import ass from "./languages/ass.js";

hljs.registerLanguage("ass", ass);
